// extracted by mini-css-extract-plugin
export default {"configuratorModalInner":"configuratorModalInner--WziIJ","productList":"productList--WUEO0","specficationBody":"specficationBody--qfCQy"};